import React from 'react'
import { ItemIcon, Label, Container, LabelLoading } from './styles'

const LoadMore = ({ onClick, w, loadingMore }) => (
  <div>
    {loadingMore ? (
      <LabelLoading>carregando</LabelLoading>
    ) : (
      <Container width={`${w}px`} className="load-more-container">
        <ItemIcon id="btnLoadMore" onClick={onClick}>
          <img src={require('./icon-plus.png')} alt="" />
        </ItemIcon>
        <Label>Carregar mais</Label>
      </Container>
    )}
  </div>
)

export default LoadMore



// WEBPACK FOOTER //
// ./src/app/elements/LoadMore/index.js